
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ProjectModal from "@/components/companyProjects/ProjectModal.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import { Project, User } from "@/generated/graphql";

  @Component({
    components: {
      UiButton,
      ProjectModal,
    },
  })
  export default class ProjectAction extends Vue {
    @Prop({ type: Object, default: undefined }) readonly project?: Project;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    modalShown: boolean = false;

    showModal(): void {
      this.modalShown = true;
    }

    hideModal(): void {
      this.modalShown =false;
    }

    get buttonText(): string {
      if (this.project) {
        return "Edit Project";
      }

      return "Add Project";
    }
  }
